import { BusinessRegistrationDto } from 'types/dtos/business-registration'

import { api } from './api'

export const submitBusinessRegistrationDsa = (registration: BusinessRegistrationDto) =>
  api.post('/business_accounts_dsa', registration)
